import { css, cx } from 'emotion';
import React, { PureComponent } from 'react';
import {
    AboutUs,
    OurPlatform,
    OurVirtualExperts,
    Partners,
    WeEmulatePeople,
} from './../components/sections';

export default class IndexPage extends PureComponent {
    render() {
        const { transition } = this.props;
        return (
            <div className={cx(transition && transition.className, s.wrapper)}>
                <div id="top" />
                <WeEmulatePeople />
                <AboutUs />
                <OurPlatform />
                <OurVirtualExperts />
                <Partners />
            </div>
        );
    }
}

const s = {};

s.wrapper = css`
    display: flex;
    flex-direction: column;
`;



// WEBPACK FOOTER //
// ./src/pages/index.js